import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Drawer,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import Options from '../../../assets/images/Options.svg';
import PaginationComponent from '../../../components/Pagination';
import ActionButtons from '../../../components/actionbutton';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import Filter from '../../../assets/images/Filter.svg';
import Assign from '../../../assets/images/Assign.svg';
import FilterDrawer from './filterDrawer';
import { useHook as InventoryUseHook } from './useHook';
import { useSelector } from 'react-redux';
import useDebounce from '../../../components/Debounce';
import AssignDrawer from './assignUserDrawer';
import { closeBlackIcon } from '../../../assets/images';
import ActiveOptions from '../../../assets/images/activeOptions.svg';
import HoverOptions from '../../../assets/images/hoverOptions.svg';

const UnRegisteredUnit = () => {
  const { unRegisteredInventoryList } = useSelector(
    (state: any) => state.inventory,
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filterDrawerOpen, setFliterDrawerOpen] = useState(false);
  const [assignDrawerOpen, setAssignDrawerOpen] = useState(false);
  const [assignOpen, setAssignOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<string[]>([]);
  const [search, setSearch] = useState<string>('');
  const debouncedSearch = useDebounce(search, 1000);
  const { fetchUnRisteredInventory, assignInventory, readyToDispatch } =
    InventoryUseHook();
  const [filterData, setFilterData] = useState<string[]>([]);
  const [equipmentData, setEquipment] = React.useState<string[]>([]);
  const [categoryData, setCategoryData] = React.useState<string[]>([]);
  const [subCategoryData, setSubCategoryData] = React.useState<string[]>([]);
  const [gatewayNo, setGatewayNo] = React.useState<string[]>([]);
  const [serialFromData, setSerialFromData] = React.useState<string>('');
  const [serialToData, setSerialToData] = React.useState<string>('');
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);
  const [assignId, setAssignId] = useState('');
  const [actionimageActive, setactionimageActive] = useState(null);
  const [actionimageHoverd, setActionimageHoverd] = useState(null);
  const [filterDrawerData, setFilterDrawerData] = useState<any>(null);

  useEffect(() => {
    if (debouncedSearch) {
      getUnRegisteredUnit(1, rowsPerPage, search);
      setCurrentPage(1);
    }
  }, [debouncedSearch]);

  //search
  const handleSearchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const search = event.target.value;
    setSearch(search);

    if (!search) {
      getUnRegisteredUnit(currentPage, rowsPerPage, search);
    } else {
      setCurrentPage(1);
    }
  };

  //assign
  const handleAssignClick = () => {
    setAnchorEl(null);
    setAssignOpen(!assignOpen);
    setSelectedRow([]);
  };
  const handleAssignmenuClick = () => {
    setAssignDrawerOpen(true);
    setAnchorEl(null);
    setactionimageActive(null);
    setActionimageHoverd(null);
    setSelectedRow([assignId]);
  };

  const handleSubmitButton = async () => {
    if (assignOpen) {
      setAssignDrawerOpen(true);
    }
  };
  const assignCloseDrawer = () => {
    setAssignDrawerOpen(false);
    setAssignId('');
  };
  const assignSubmit = async (data: any) => {
    const payload = {
      userID: data?.userID,
      unitIDs: assignId ? [assignId] : selectedRow,
    };
    await assignInventory(payload);
    setSelectedRow([]);
    setAssignDrawerOpen(false);
    setAssignId('');
  };

  //filter
  const fliterOpenDrawer = () => {
    setFliterDrawerOpen(true);
    setAssignOpen(false);
  };
  const fliterCloseDrawer = () => {
    setFliterDrawerOpen(false);
  };

  useEffect(() => {
    getUnRegisteredUnit(currentPage, rowsPerPage, search);
    const trimmedSerialFromData = serialFromData.trim();
    const trimmedSerialToData = serialToData.trim();

    const updateFilterData = [
      ...equipmentData,
      ...categoryData,
      ...subCategoryData,
      ...gatewayNo,
      ...(trimmedSerialFromData ? [trimmedSerialFromData] : []), // Include only trimmed non-empty serialNumberFrom
      ...(trimmedSerialToData ? [trimmedSerialToData] : []), // Include only trimmed non-empty serialNumberTo
    ];
    setSeeMoreIndex(updateFilterData?.length);
    setFilterData(updateFilterData);
    setFilterDrawerData({
      serialNumberFrom: serialFromData,
      serialNumberTo: serialToData,
      equipmentModel: equipmentData?.length > 0 ? equipmentData : [],
      category: categoryData?.length > 0 ? categoryData : [],
      subCategory: subCategoryData?.length > 0 ? subCategoryData : [],
      gatewayNo: gatewayNo?.length > 0 ? gatewayNo : [],
    });
  }, [
    serialFromData,
    serialToData,
    equipmentData,
    categoryData,
    subCategoryData,
    gatewayNo,
  ]);

  const filterSubmit = (data: any) => {
    setFilterData([
      ...data.equipmentModel,
      ...data.category,
      ...data.subCategory,
      ...data.gatewayNo,
      ...(data.serialNumberFrom?.trim() ? [data.serialNumberFrom.trim()] : []), // Include only trimmed non-empty serialNumberFrom
      ...(data.serialNumberTo?.trim() ? [data.serialNumberTo.trim()] : []), // Include only trimmed non-empty serialNumberTo
    ]);
    setEquipment(data.equipmentModel);
    setCategoryData(data.category);
    setSubCategoryData(data.subCategory);
    setGatewayNo(data.gatewayNo);
    setSerialFromData(data.serialNumberFrom);
    setSerialToData(data.serialNumberTo);
    setCurrentPage(1);
  };
  const handleRemoveFilter = (filterName: string) => {
    if (equipmentData.includes(filterName)) {
      const removeData = equipmentData?.filter((data) => data !== filterName);
      setEquipment(removeData);
    } else if (categoryData.includes(filterName)) {
      const removeData = categoryData?.filter((data) => data !== filterName);
      setCategoryData(removeData);
    } else if (subCategoryData.includes(filterName)) {
      const removeData = subCategoryData?.filter((data) => data !== filterName);
      setSubCategoryData(removeData);
    } else if (gatewayNo.includes(filterName)) {
      const removeData = gatewayNo?.filter((data) => data !== filterName);
      setGatewayNo(removeData);
    } else if (serialFromData === filterName) {
      setSerialFromData('');
    } else if (serialToData === filterName) {
      setSerialToData('');
    }
    const removeData = filterData?.filter((data) => data !== filterName);
    setFilterData(removeData);
    setCurrentPage(1);
  };

  //pagination
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getUnRegisteredUnit(page, rowsPerPage, search);
  };
  const handleRowsPerPageChange = (value: number) => {
    getUnRegisteredUnit(1, value, search);
    setRowsPerPage(value);
    setCurrentPage(1);
  };

  //menu
  const handleMenuClick = (event: any, index: any, id: any) => {
    setactionimageActive(index);
    setAnchorEl(event.currentTarget);
    setAssignId(id);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setactionimageActive(null);
    setActionimageHoverd(null);
  };

  const actionimageMouseEnter = (id: any) => {
    setActionimageHoverd(id);
  };

  const actionimageMouseLeave = () => {
    setActionimageHoverd(null);
  };

  //getdata
  const getUnRegisteredUnit = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    filters?: any,
    sort: { orderBy: string; order: number } = {
      orderBy: 'updatedAt',
      order: -1,
    },
  ) => {
    const payload = {
      sort: sort,
      search: search,
      filters: {
        serialNumberFrom: serialFromData,
        serialNumberTo: serialToData,
        equipmentModel: equipmentData?.length > 0 ? equipmentData : null,
        category: categoryData?.length > 0 ? categoryData : null,
        subCategory: subCategoryData?.length > 0 ? subCategoryData : null,
        gatewayNo: gatewayNo?.length > 0 ? gatewayNo : null,
      },
      limit: row_perpage ? row_perpage : rowsPerPage,
      offset: pagenumber
        ? (pagenumber - 1) * rowsPerPage
        : (currentPage - 1) * rowsPerPage,
    };
    await fetchUnRisteredInventory(payload).then((res: any) => {
      const totalPage = res?.count
        ? Math.ceil(res?.count / (row_perpage ? row_perpage : rowsPerPage))
        : 1;
      setTotalPages(totalPage);
    });
  };

  //row select
  const handleSelectedRow = (selectName: string) => {
    setSelectedRow((prevselected) => {
      if (prevselected.includes(selectName)) {
        const updatedData = prevselected.filter(
          (names) => names !== selectName,
        );
        return updatedData;
      } else {
        const updatedData = [...prevselected, selectName];
        return updatedData;
      }
    });
  };
  const handleAllRowSelect = (event: { target: { checked: any } }) => {
    if (event.target.checked) {
      const newSelecteds = unRegisteredInventoryList?.map(
        (data: any) => data?.unitID,
      );
      setSelectedRow(newSelecteds);
      return;
    }
    setSelectedRow([]);
  };

  //dateformat
  function formatDate(isoDate: any) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  return (
    <>
      <section className="dashboard-header">
        <div className="dashboard-header_card-container">
          <div className="dashboard-header_card">
            <ActionButtons
              image={Filter}
              title={'Filter'}
              action={fliterOpenDrawer}
              activeData={filterData}
            />
          </div>
          <div className="dashboard-header_card">
            <ActionButtons
              image={Assign}
              title={'Assign'}
              action={handleAssignClick}
              activeButton={assignOpen}
            />
          </div>
        </div>
        <div className="table-header-btn">
          <TextField
            variant="outlined"
            placeholder="Search"
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: <SearchIcon />,
            }}
            className="search-input"
          />
        </div>
      </section>

      <section>
        {filterData?.slice(0, seeMoreIndex).map((data, index) => (
          <div key={index} className="filterlist">
            <p>{data}</p>
            <Button onClick={() => handleRemoveFilter(data)}>
              <img src={closeBlackIcon} alt="Delete Icon" width={13} />
            </Button>
          </div>
        ))}
        {filterData?.length > 2 && seeMoreIndex === 2 && (
          <div className="see_more_data">
            <Button
              onClick={() => setSeeMoreIndex(filterData?.length)}
            >{`+${filterData?.length - 2} More`}</Button>
          </div>
        )}
        {filterData?.length > 2 && seeMoreIndex !== 2 && (
          <div className="see_more_data">
            <Button onClick={() => setSeeMoreIndex(2)}>show less</Button>
          </div>
        )}
      </section>

      <TableContainer className="dashboard_table-container " component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {assignOpen && (
                <TableCell>
                  <Checkbox
                    indeterminate={
                      selectedRow.length > 0 &&
                      selectedRow.length < unRegisteredInventoryList.length
                    }
                    checked={
                      selectedRow.length > 0 &&
                      unRegisteredInventoryList.length === selectedRow.length
                    }
                    onChange={handleAllRowSelect}
                  />
                </TableCell>
              )}
              <TableCell>Serial No</TableCell>
              <TableCell>Equipment Type</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Sub-category</TableCell>
              <TableCell>Maintenance</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {unRegisteredInventoryList?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2}>
                  <Typography variant="body1" align="left">
                    No Data found
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              unRegisteredInventoryList?.map((data: any, index: any) => (
                <TableRow key={index}>
                  {assignOpen && (
                    <TableCell>
                      <Checkbox
                        checked={selectedRow.includes(String(data?.unitID))}
                        onChange={() => {
                          handleSelectedRow(data?.unitID);
                        }}
                      />
                    </TableCell>
                  )}
                  <TableCell>
                    <p>{data?.serialNumber}</p>
                  </TableCell>
                  <TableCell>
                    <p>{data?.equipmentModel}</p>
                  </TableCell>
                  <TableCell>
                    <p>{data?.category}</p>
                  </TableCell>
                  <TableCell>
                    <p>{data?.subCategory}</p>
                  </TableCell>
                  <TableCell>
                    <div className="inventory-modifiedfield">
                      <Typography>{formatDate(data.createdAt)}</Typography>
                      <button
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={(e) => handleMenuClick(e, index, data?.unitID)}
                      >
                        {actionimageActive === index ? (
                          <img src={ActiveOptions} alt="Option img" />
                        ) : (
                          <img
                            key={index}
                            src={
                              actionimageHoverd === index
                                ? HoverOptions
                                : Options
                            }
                            alt="Option img"
                            onMouseEnter={() => actionimageMouseEnter(index)}
                            onMouseLeave={actionimageMouseLeave}
                          />
                        )}
                      </button>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <PaginationComponent
        rowsPerPageOptions={[5, 10, 20, 30]}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        totalPages={totalPages}
      />
      {assignOpen ? (
        <div className="inventory_assign_submitbtn-container">
          <Button
            variant="contained"
            onClick={handleSubmitButton}
            className={
              selectedRow.length > 0
                ? 'save_button'
                : 'save_button disabled_button'
            }
            disabled={!(selectedRow.length > 0)}
          >
            Assign
          </Button>
        </div>
      ) : (
        <></>
      )}

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        className="dashboard-menu"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={handleAssignmenuClick}
          className="menuItem edit_icon"
        >
          <img src={Assign} alt="Edit" />
          Assign
        </MenuItem>
      </Menu>

      <Drawer
        open={filterDrawerOpen}
        anchor="right"
        onClose={fliterCloseDrawer}
      >
        <FilterDrawer
          fliterCloseDrawer={fliterCloseDrawer}
          filterSubmit={filterSubmit}
          filterDrawerData={filterDrawerData}
        />
      </Drawer>
      <Drawer
        open={assignDrawerOpen}
        anchor="right"
        onClose={assignCloseDrawer}
      >
        <AssignDrawer
          assignCloseDrawer={assignCloseDrawer}
          assignSubmit={assignSubmit}
        />
      </Drawer>
    </>
  );
};

export default UnRegisteredUnit;
